import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAppStore } from "@/stores/RootStore";
import { Separator } from "@/ui/Separator";
import { Header } from "@/components/Header";
import { AdminSensorType, DeviceModel, SelectOption } from "@/types/types";
import { useFetch } from "@/hooks/useFetch";
import Spinner from "@/ui/Spinner/Spinner";

import SensorsGrid from "./SensorsGrid";

export const Sensors = () => {
  let { id } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite;

  const [loading, setLoading] = useState(true);
    const [{ response, isLoading, error }, doFetchItem] = useFetch(`/administration/directories/sensor_types`, true);
    const [sensors, setSensors] = useState<AdminSensorType[]>();
  
    useEffect(() => {
      setLoading(true);
      doFetchItem();
    }, []);
  
    useEffect(() => {
      if (!response) {
        return;
      }
      setSensors(response.data as unknown as AdminSensorType[]);
      setLoading(false);
    }, [response]);

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">
              {currentSite?.name ? currentSite?.name : "..."}
            </span>
          </NavLink>
          <span>/</span>
          <NavLink to={"/admin"}>
            <span className="font-medium">{t("admin")}</span>
          </NavLink>
          <span>/</span>
          {location.pathname == "/admin/sensors/" ||
          location.pathname == "/admin/sensors" ? (
            <span>{t("sensors")}</span>
          ) : (
            <NavLink to={"/admin/sensors"}>
              <span>{t("sensors")}</span>
            </NavLink>
          )}
          {(id || location.pathname == "/admin/sensors/new") && <span>/</span>}
          {id && (
            <span>{sensors?.find((n) => n.id == id)?.attributes.name}</span>
          )}
          {location.pathname == "/admin/sensors/new" && (
            <span>{t("adding_sensor")}</span>
          )}
        </div>
      </div>
      <Separator className="flex-none" />
      {id || location.pathname == "/admin/sensors/new" ? (
        <Outlet context={[sensors, setSensors]} />
      ) : (
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header
            name={t("sensors")}
            backName={t("admin")}
            backLink={"/admin"}
          />
          {loading ? (
            <Spinner />
          ) : (
            <SensorsGrid sensors={sensors!} onClose={empty} />
          )}
        </div>
      )}
    </div>
  );
};
